import { EmptyUUID } from './constants'

export const falsyOrUUID = (uuid?: string) => (uuid !== EmptyUUID ? uuid : false)
